import { createApiHooks } from '@apis/next/common';
import {
  RoutePlanSimulatorType,
  PostRoutePlanSimulator,
  RoutePlanSimulator,
  RoutePlanSimulatorStatus,
} from '@models/next/RoutePlanSimulator';

export const routePlanSimulatorApis = createApiHooks('/route-plan-simulator', [
  {
    path: '/',
    method: 'get',
    response: RoutePlanSimulatorStatus,
  },
  {
    path: '/',
    method: 'post',
    parameters: [
      {
        type: 'Query',
        name: 'type',
        schema: RoutePlanSimulatorType,
      },
      {
        type: 'Body',
        name: 'body',
        schema: PostRoutePlanSimulator,
      },
    ],
    response: RoutePlanSimulator.array(),
  },
]);
